var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.kindMeta)?_c('v-chip',{staticClass:"font-weight-medium",style:(_setup.kindMeta.style),attrs:{"small":"","label":""}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(_vm._s(_setup.kindMeta.icon))]),_vm._v("\n  "+_vm._s(_vm.$t(_setup.kindMeta.labelKey))+"\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }